import { useNavigate } from 'react-router-dom';
import { IError } from 'types';
import routes from 'constants/routes';
import { showErrorMessage } from '.';
import { NOTIFICATION } from '../constants';

interface HandleErrorOptions {
  notFoundMessage?: string;
}

export const handleError = (
  err: IError['error'],
  navigate: ReturnType<typeof useNavigate>,
  options?: HandleErrorOptions
) => {
  const notFoundMessage = options?.notFoundMessage ?? NOTIFICATION.THREAD_NOT_FOUND;

  if (err.status === 404) {
    showErrorMessage(notFoundMessage);
  } else {
    showErrorMessage(err.data.detail);
  }
  navigate(routes.dashboard);
};
